import { useLocation } from 'js/lib/useRouter';
import { isPoweruser } from 'js/lib/user';

const useIsPreview = () => {
  const { query } = useLocation();

  return !!isPoweruser() && (query.preview === 'true' || query.preview === '1');
};

export default useIsPreview;
